import { render, staticRenderFns } from "./Homev2.vue?vue&type=template&id=3a98a950&scoped=true&"
import script from "./Homev2.vue?vue&type=script&lang=js&"
export * from "./Homev2.vue?vue&type=script&lang=js&"
import style0 from "./Homev2.vue?vue&type=style&index=0&id=3a98a950&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a98a950",
  null
  
)

export default component.exports